// Fichier : src/redux/sign-in/signinSlice.js (LA CORRECTION DÉFINITIVE)

import { createSlice } from "@reduxjs/toolkit";

// Cette fonction est la clé. Elle lit le localStorage AU DÉMARRAGE de l'application.
const loadUserFromStorage = () => {
  try {
    const serializedUser = localStorage.getItem('user');
    if (serializedUser === null) {
      return null; // Pas d'utilisateur sauvegardé
    }
    return JSON.parse(serializedUser); // On parse l'utilisateur
  } catch (e) {
    console.error("Erreur en chargeant l'utilisateur depuis le localStorage", e);
    return null;
  }
};

const initialState = {
  token: localStorage.getItem('jwtToken') || null,
  user: loadUserFromStorage(),
  isLoading: false,
  error: null,
  data: {
    email: '',
    password: ''
  },
};

const signinSlice = createSlice({
  name: "signin",
  initialState,
  reducers: {
    signinStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    signinSuccess(state, action) {
      state.isLoading = false;
      state.token = action.payload.token;
      state.user = action.payload.user;

      // ET ON SAUVEGARDE DANS LE LOCALSTORAGE
      localStorage.setItem('jwtToken', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
    },
    signinFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
      state.user = null;
      
      // ON NETTOIE TOUT
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('user');
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    updateData: (state, action) => {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
  },
});

export const { signinStart, signinSuccess, signinFailure, clearToken, setUser, updateData } =
  signinSlice.actions;

export default signinSlice.reducer;